import api from "../http/api";

export const insightsInstitution = async ({ institutionId, startDate, endDate }) => {
  try {
    const queryParams = new URLSearchParams();

    if (startDate !== undefined && startDate !== null) {
      queryParams.append('startDate', startDate);
    }

    if (endDate !== undefined && endDate !== null) {
      queryParams.append('endDate', endDate);
    }

    const response = await api.client.get(
      `api/v1/InsightsInstitution?${queryParams.toString()}`,
      {
        headers: {
          institutionId: institutionId,
        },
      }
    );

    return response.data;
  } catch (error) {
    throw new Error("Falha na conexão com a API de insights");
  }
};


export const getInstitutionAverageTicketHistory = async ({ institutionId, years = 5 }) => {
  if (!institutionId) {
    throw new Error("institutionId obrigatório para buscar histórico de ticket médio.");
  }

  try {
    const queryParams = new URLSearchParams();
    queryParams.append("years", String(years));

    const response = await api.client.get(
      `api/v1/InsightsInstitution/AverageTicketHistory?${queryParams.toString()}`,
      {
        headers: { institutionId: institutionId },
      }
    );

    return response.data;
  } catch (error) {
    if (error?.response?.status === 403) {
      throw new Error("Você não tem permissão para acessar o histórico de ticket médio desta instituição.");
    }
    throw new Error(
      error?.response?.data?.error || "Falha ao buscar histórico de ticket médio."
    );
  }
};

export const getInstitutionMonthlyAverageTicket = async ({ institutionId, year }) => {
  if (!institutionId) {
    throw new Error("institutionId obrigatório para buscar ticket médio mensal.");
  }
  if (!year) {
    throw new Error("year obrigatório para buscar ticket médio mensal.");
  }

  try {
    const queryParams = new URLSearchParams();
    queryParams.append("year", String(year));

    const response = await api.client.get(
      `api/v1/InsightsInstitution/AverageTicketHistory/Monthly?${queryParams.toString()}`,
      {
        headers: { institutionId: institutionId },
      }
    );

    return response.data;
  } catch (error) {
    if (error?.response?.status === 403) {
      throw new Error("Você não tem permissão para acessar o ticket médio mensal desta instituição.");
    }
    throw new Error(
      error?.response?.data?.error || "Falha ao buscar ticket médio mensal."
    );
  }
};


export const getInstitutionMonthlyRevenue = async ({ institutionId, year }) => {
  if (!institutionId) {
    throw new Error("institutionId obrigatório para buscar receita mensal.");
  }
  if (!year) {
    throw new Error("year obrigatório para buscar receita mensal.");
  }

  try {
    const queryParams = new URLSearchParams();
    queryParams.append("year", String(year));

    const response = await api.client.get(
      `api/v1/InsightsInstitution/RevenueHistory/Monthly?${queryParams.toString()}`,
      {
        headers: {
          institutionId: institutionId,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error?.response?.status === 403) {
      throw new Error("Você não tem permissão para acessar a receita mensal desta instituição.");
    }
    throw new Error(
      error?.response?.data?.error || "Falha ao buscar receita mensal."
    );
  }
};


export const getInstitutionRevenueHistory = async ({ institutionId, years = 5 }) => {
  if (!institutionId) {
    throw new Error("institutionId obrigatório para buscar histórico de receita.");
  }

  try {
    const queryParams = new URLSearchParams();
    queryParams.append("years", String(years));

    const response = await api.client.get(
      `api/v1/InsightsInstitution/RevenueHistory?${queryParams.toString()}`,
      {
        headers: {
          institutionId: institutionId,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error?.response?.status === 403) {
      throw new Error("Você não tem permissão para acessar o histórico de receita desta instituição.");
    }
    throw new Error(
      error?.response?.data?.error || "Falha ao buscar histórico de receita."
    );
  }
};

export const getInstitutionMonthlyBilling = async ({ institutionId, year }) => {
  if (!institutionId) {
    throw new Error("institutionId obrigatório para buscar faturamento mensal.");
  }
  if (!year) {
    throw new Error("year obrigatório para buscar faturamento mensal.");
  }

  try {
    const queryParams = new URLSearchParams();
    queryParams.append("year", String(year));

    const response = await api.client.get(
      `api/v1/InsightsInstitution/BillingHistory/Monthly?${queryParams.toString()}`,
      {
        headers: { institutionId: institutionId },
      }
    );

    return response.data;
  } catch (error) {
    if (error?.response?.status === 403) {
      throw new Error("Você não tem permissão para acessar o faturamento mensal desta instituição.");
    }
    throw new Error(
      error?.response?.data?.error || "Falha ao buscar faturamento mensal."
    );
  }
};

export const getInstitutionBillingHistory = async ({ institutionId, years = 5 }) => {
  if (!institutionId) {
    throw new Error("institutionId obrigatório para buscar histórico de faturamento.");
  }

  try {
    const queryParams = new URLSearchParams();
    queryParams.append("years", String(years));

    const response = await api.client.get(
      `api/v1/InsightsInstitution/BillingHistory?${queryParams.toString()}`,
      {
        headers: { institutionId: institutionId },
      }
    );

    return response.data;
  } catch (error) {
    if (error?.response?.status === 403) {
      throw new Error("Você não tem permissão para acessar o histórico de faturamento desta instituição.");
    }
    throw new Error(
      error?.response?.data?.error || "Falha ao buscar histórico de faturamento."
    );
  }
};


export const insightsFilters = async ({
  institutionId,
  KnowledgeAreaFilter,
  filterClass,
  predictiveFilter
}) => {
  try {
    const response = await api.client.get(
      `api/v1/FilterPredictiveData?FilterData=${predictiveFilter}&KnowledgeAreaFilter=${KnowledgeAreaFilter}&filterClass=${filterClass}`,
      {
        headers: {
          institutionId: institutionId
        }       
      }
    );

    console.log('filterpredictivedata', response)

    // Sanitiza os valores de filtro: remove entradas nulas/indefinidas vindas da API
    // (ex.: quando não há dados de Class importados ou há valores nulos no resultado).
    // Centralizar aqui garante o mesmo tratamento para todos os consumidores.
    const data = response.data || {};
    if (Array.isArray(data.filterValues)) {
      data.filterValues = data.filterValues.filter(
        (opt) => opt !== null && opt !== undefined
      );
    }

    return data;
  } catch (error) {
    throw new Error("Falha na conexão com a API de login");
  }
}